import { Schema } from "@/modules/FormTemplate/models/Schema";
import { UISetup } from "../../../shared/models/UISetup";

export class FieldOrder {
  order!: number;
  type!: string;
  list!: string;
  key!: string;
  conversationTitle!: string;
  required!: boolean;
  visible!: boolean;
  editable!: boolean;
  visualElement!: string;
  uiSetup?: UISetup;
  schema!: Schema;
  default?: boolean;
  visibleDashboard?: boolean;
  editableDashboard?: boolean;
}
